import CookiePopup from './CookiePopup';

export default CookiePopup;
